import React, { useState, useEffect, Fragment } from "react";

import "../styles/Weather.css";
import WeatherCard from "./WeatherCard";

const cities = ["paris", "london", "tokyo", "new york", "casablanca"];

function Weather() {
  const WEATHER_API_KEY = process.env.REACT_APP_WEATHER_API_KEY;

  const [nameOfCities, setNameOfCities] = useState([]);
  const [weatherImg, setWeatherImg] = useState([]);
  const [forcastWeather, setForcastWeather] = useState([]);
  const [radioValue, setRadioValue] = useState(0);
  const [formValue, setFormValue] = useState(0);

  const switchCity = (e) => {
    setRadioValue(e.target.value);
  };

  let formCount = -1;

  const displayForm = nameOfCities.map((name, index) => {
    formCount++;
    return (
      <Fragment key={index}>
        <input
          type="radio"
          name="city"
          value={formCount}
          id={name}
          onChange={switchCity}
        />
        <label className="form-check-label" htmlFor={name}>
          {name}
        </label>
        <br />
      </Fragment>
    );
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormValue(radioValue);
  };

  useEffect(() => {
    cities.forEach((city) => {
      fetch(
        `https://weatherapi-com.p.rapidapi.com/forecast.json?q=${city}&days=3`,
        {
          method: "GET",
          headers: {
            "x-rapidapi-host": "weatherapi-com.p.rapidapi.com",
            "x-rapidapi-key": WEATHER_API_KEY,
          },
        }
      )
        .then(function (res) {
          if (res.ok) {
            return res.json();
          }
        })
        .then((response) => {
          setNameOfCities((nameOfCities) => [
            ...nameOfCities,
            response.location.name,
          ]);
          setWeatherImg((weatherImg) => [
            ...weatherImg,
            response.current.condition.icon,
          ]);
          setForcastWeather((forcastWeather) => [
            ...forcastWeather,
            response.current.condition.text,
          ]);
        })
        .catch((err) => {
          console.error(err);
        });
    });
  }, []);

  return (
    <Fragment>
      <h1>Weahter</h1>
      <h2>Select a city :</h2>
      <div className="form-container">
        <form className="form-check" onSubmit={handleSubmit}>
          {displayForm}
          <input type="submit" className="btn btn-primary" value="Send" />
        </form>
      </div>
      <div className="row">
        <WeatherCard
          key={nameOfCities[formValue]}
          name={nameOfCities[formValue]}
          image={weatherImg[formValue]}
          forcastWeather={forcastWeather[formValue]}
        />
      </div>
    </Fragment>
  );
}

export default Weather;
